import { createSlice } from '@reduxjs/toolkit';
import { createApiThunkPrivate, createExtraReducersForThunk } from '../../utils/apiThunk';
import { sessionStorageRemoveItem } from '../../utils/globalFunction';

const initialState = {
  value: 0,
  loading: false,
  error: "",
  dashboardData: {},
  languageListData: {},
  updateLanguageData: {},
  createLanguageData: {},
  deleteLanguageData: {},
  updateLangugaeStatusData: {},
  getUserListData: {},
  updateUserData: {},
  deleteUserData: {},
  getAllCountryCodeListApiSuccessData: {},
  createNewUserData: {},
  getAllSkillAnalysesData: {},
  getAllSkillIndicatorData: {},
  getLanguageListForAdminData: {},
  createSkillAnalysesData: {},
  deleteSkillAnalysesData: {},
  updateSkillAnalysesData: {},
  getSkillAnalysesByIdData: {},
  getCountryLanguageManagementListData: {},
  getAllCountryCodeListApiData: {},
  getAllLanguageData: {},
  createCountryLanguageManagementData: {},
  updateCountryLanguageManagementData: {},
  getFirstScreenListData: {},
  updateCountryLanguageManagementStatusData: {},
  updateFirstScreenData: {},
  getIntroductionListData: {},
  deleteIntroductionData: {},
  createNewIntroductionData: {},
  updateQuestionData: {},
  getLanguageSetting2ListData: {},
  getAllServiceData: {},
  deleteServiceData: {},
  createNewServiceData: {},
  getServiceByIdData: {},
  updateServiceData: {},
  createLanguageSetting2Data: {},
  getLanguageSetting2ByIdData: {},
  updateLanguageSetting2Data: {},
  updateBoardData: {},
  getSkillAnalysesListData: {},
  bulkImportLanguageSettingData: {},
  getAllLanguageSetting2Data: {},
  getQuestionDataData2: {},
  bulkImportQuestionDataData2: {},
  getAllUserDataByQueryData: {},
  getAllStudentDataByQueryData: {},
  deleteCountryLanguageManagementData: {},
  getScoreListForAdminData: {},
  previousScoreListingData: {},
  reportDataForStudentIdData: {},
  getSplashScreenListData:{},
  getAllCourseData:{}


};


export const getDashboardData = createApiThunkPrivate('getDashboardData', '/getDashboardData')
export const getLanguageList = createApiThunkPrivate('getLanguageList', '/getLanguageListForAdmin')
export const updateLanguage = createApiThunkPrivate('updateLanguage', '/updateLanguage')
export const createLanguage = createApiThunkPrivate('createLanguage', '/createLanguage')
export const deleteLanguage = createApiThunkPrivate('deleteLanguage', '/deleteLanguage')
export const updateLangugaeStatus = createApiThunkPrivate('updateLangugaeStatus', '/updateLangugaeStatus')
export const getUserList = createApiThunkPrivate('getUserList', '/getUserList')
export const updateUser = createApiThunkPrivate('updateUser', '/updateUser')
export const deleteUser = createApiThunkPrivate('deleteUser', '/deleteUser')
export const getAllCountryCodeListApiSuccess = createApiThunkPrivate('getAllCountryCodeListApiSuccess', '/getAllCountryCodeListApiSuccess')
export const createNewUser = createApiThunkPrivate('createNewUser', '/createNewUser')
export const getAllSkillAnalyses = createApiThunkPrivate('getAllSkillAnalyses', '/getAllSkillAnalyses')
export const getAllSkillIndicator = createApiThunkPrivate('getAllSkillIndicator', '/getAllSkillIndicator')
export const getLanguageListForAdmin = createApiThunkPrivate('getLanguageListForAdmin', '/getLanguageListForAdmin')
export const createSkillAnalyses = createApiThunkPrivate('createSkillAnalyses', '/createSkillAnalyses')
export const deleteSkillAnalyses = createApiThunkPrivate('deleteSkillAnalyses', '/deleteSkillAnalyses')
export const getSkillAnalysesById = createApiThunkPrivate('getSkillAnalysesById', '/getSkillAnalysesById')
export const getScoreListForAdmin = createApiThunkPrivate('getScoreListForAdmin', '/getScoreListForAdmin')

export const updateSkillAnalyses = createApiThunkPrivate('updateSkillAnalyses', '/updateSkillAnalyses')
export const getCountryLanguageManagementList = createApiThunkPrivate('getCountryLanguageManagementList', '/getCountryLanguageManagementList')
export const getAllCountryCodeListApi = createApiThunkPrivate('getAllCountryCodeListApi', '/getAllCountryCodeListApi')
export const getAllCourse = createApiThunkPrivate('getAllCourse', '/getAllCourse')
export const getAllLanguage = createApiThunkPrivate('getAllLanguage', '/getAllLanguage')
export const createCountryLanguageManagement = createApiThunkPrivate('createCountryLanguageManagement', '/createCountryLanguageManagement')
export const updateCountryLanguageManagement = createApiThunkPrivate('updateCountryLanguageManagement', '/updateCountryLanguageManagement')
export const getFirstScreenList = createApiThunkPrivate('getFirstScreenList', '/getFirstScreenList')
export const updateCountryLanguageManagementStatus = createApiThunkPrivate('updateCountryLanguageManagementStatus', '/updateCountryLanguageManagementStatus')
export const deleteCountryLanguageManagement = createApiThunkPrivate('deleteCountryLanguageManagement', '/deleteCountryLanguageManagement')
export const updateFirstScreen = createApiThunkPrivate('updateFirstScreen', '/updateFirstScreen')
export const getIntroductionList = createApiThunkPrivate('getIntroductionList', '/getIntroductionList')
export const deleteIntroduction = createApiThunkPrivate('deleteIntroduction', '/deleteIntroduction')
export const createNewIntroduction = createApiThunkPrivate('createNewIntroduction', '/createNewIntroduction')
export const updateQuestion = createApiThunkPrivate('updateQuestion', '/updateQuestion')
export const getLanguageSetting2List = createApiThunkPrivate('getLanguageSetting2List', '/getLanguageSetting2List')
export const getAllService = createApiThunkPrivate('getAllService', '/getServiceList')
export const deleteService = createApiThunkPrivate('deleteService', '/deleteService')
export const createNewService = createApiThunkPrivate('createNewService', '/createNewService')
export const getServiceById = createApiThunkPrivate('getServiceById', '/getServiceById')
export const updateService = createApiThunkPrivate('updateService', '/updateService')
export const createLanguageSetting2 = createApiThunkPrivate('createLanguageSetting2', '/createLanguageSetting2')
export const getLanguageSetting2ById = createApiThunkPrivate('getLanguageSetting2ById', '/getLanguageSetting2ById')
export const updateLanguageSetting2 = createApiThunkPrivate('updateLanguageSetting2', '/updateLanguageSetting2')
export const updateBoard = createApiThunkPrivate('updateBoard', '/updateCourse')
export const getSkillAnalysesList = createApiThunkPrivate('getSkillAnalysesList', '/getSkillAnalysesList')
export const bulkImportLanguageSetting = createApiThunkPrivate('bulkImportLanguageSetting', '/bulkImportLanguageSetting')
export const getAllLanguageSetting2 = createApiThunkPrivate('getAllLanguageSetting2', '/getAllLanguageSetting2')
export const getQuestionData = createApiThunkPrivate('getQuestionData', '/getQuestionData')
export const bulkImportQuestionData = createApiThunkPrivate('bulkImportQuestionData', '/bulkImportQuestionData')
export const getAllUserDataByQuery = createApiThunkPrivate('getAllUserDataByQuery', '/getAllUserDataByQuery')
export const getAllStudentDataByQuery = createApiThunkPrivate('getAllStudentDataByQuery', '/getAllStudentDataByQuery')
export const previousScoreListing = createApiThunkPrivate('previousScoreListing', '/previousScoreListing')
export const reportDataForStudentId = createApiThunkPrivate('reportDataForStudentId', '/reportDataForStudentId')


export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logout: (state) => {
      sessionStorageRemoveItem(); // clear tokens/session
      Object.keys(state).forEach((key) => {
        state[key] = {}; // reset all objects in state
      });
      state.value = 0;
      state.loading = false;
      state.error = "";
      window.location.href = "/login"
    }
  },
  extraReducers: (builder) => {
    createExtraReducersForThunk(builder, getDashboardData, 'dashboardData')
    createExtraReducersForThunk(builder, getLanguageList, 'languageListData')
    createExtraReducersForThunk(builder, updateLanguage, 'updateLanguageData')
    createExtraReducersForThunk(builder, createLanguage, 'createLanguageData')
    createExtraReducersForThunk(builder, deleteLanguage, 'deleteLanguageData')
    createExtraReducersForThunk(builder, updateLangugaeStatus, 'updateLangugaeStatusData')
    createExtraReducersForThunk(builder, getUserList, 'getUserListData')
    createExtraReducersForThunk(builder, updateUser, 'updateUserData')
    createExtraReducersForThunk(builder, deleteUser, 'deleteUserData')
    createExtraReducersForThunk(builder, getAllCountryCodeListApiSuccess, 'getAllCountryCodeListApiSuccessData')
    createExtraReducersForThunk(builder, createNewUser, 'createNewUserData')
    createExtraReducersForThunk(builder, getAllSkillAnalyses, 'getAllSkillAnalysesData')
    createExtraReducersForThunk(builder, getAllSkillIndicator, 'getAllSkillIndicatorData')
    createExtraReducersForThunk(builder, getLanguageListForAdmin, 'getLanguageListForAdminData')
    createExtraReducersForThunk(builder, createSkillAnalyses, 'createSkillAnalysesData')
    createExtraReducersForThunk(builder, deleteSkillAnalyses, 'deleteSkillAnalysesData')
    createExtraReducersForThunk(builder, getSkillAnalysesById, 'getSkillAnalysesByIdData')
    createExtraReducersForThunk(builder, updateSkillAnalyses, 'updateSkillAnalysesData')
    createExtraReducersForThunk(builder, getCountryLanguageManagementList, 'getCountryLanguageManagementListData')
    createExtraReducersForThunk(builder, getAllCountryCodeListApi, 'getAllCountryCodeListApiData')
    createExtraReducersForThunk(builder, getAllCourse, 'getAllCourseData')
    createExtraReducersForThunk(builder, getAllLanguage, 'getAllLanguageData')
    createExtraReducersForThunk(builder, createCountryLanguageManagement, 'createCountryLanguageManagementData')
    createExtraReducersForThunk(builder, updateCountryLanguageManagement, 'updateCountryLanguageManagementData')
    createExtraReducersForThunk(builder, deleteCountryLanguageManagement, 'deleteCountryLanguageManagementData')
    createExtraReducersForThunk(builder, getFirstScreenList, 'getFirstScreenListData')
    createExtraReducersForThunk(builder, updateCountryLanguageManagementStatus, 'updateCountryLanguageManagementStatusData')
    createExtraReducersForThunk(builder, updateFirstScreen, 'updateFirstScreenData')
    createExtraReducersForThunk(builder, getIntroductionList, 'getIntroductionListData')
    createExtraReducersForThunk(builder, deleteIntroduction, 'deleteIntroductionData')
    createExtraReducersForThunk(builder, createNewIntroduction, 'createNewIntroductionData')
    createExtraReducersForThunk(builder, updateQuestion, 'updateQuestionData')
    createExtraReducersForThunk(builder, getLanguageSetting2List, 'getLanguageSetting2ListData')
    createExtraReducersForThunk(builder, getAllService, 'getAllServiceData')
    createExtraReducersForThunk(builder, deleteService, 'deleteServiceData')
    createExtraReducersForThunk(builder, createNewService, 'createNewServiceData')
    createExtraReducersForThunk(builder, getServiceById, 'getServiceByIdData')
    createExtraReducersForThunk(builder, updateService, 'updateServiceData')
    createExtraReducersForThunk(builder, createLanguageSetting2, 'createLanguageSetting2Data')
    createExtraReducersForThunk(builder, getLanguageSetting2ById, 'getLanguageSetting2ByIdData')
    createExtraReducersForThunk(builder, updateLanguageSetting2, 'updateLanguageSetting2Data')
    createExtraReducersForThunk(builder, updateBoard, 'updateBoardData')
    createExtraReducersForThunk(builder, getSkillAnalysesList, 'getSkillAnalysesListData')
    createExtraReducersForThunk(builder, bulkImportLanguageSetting, 'bulkImportLanguageSettingData')
    createExtraReducersForThunk(builder, getAllLanguageSetting2, 'getAllLanguageSetting2Data')
    createExtraReducersForThunk(builder, getQuestionData, 'getQuestionDataData2')
    createExtraReducersForThunk(builder, bulkImportQuestionData, 'bulkImportQuestionDataData2')
    createExtraReducersForThunk(builder, getAllUserDataByQuery, 'getAllUserDataByQueryData')
    createExtraReducersForThunk(builder, getAllStudentDataByQuery, 'getAllStudentDataByQueryData')
    createExtraReducersForThunk(builder, getScoreListForAdmin, 'getScoreListForAdminData')
    createExtraReducersForThunk(builder, previousScoreListing, 'previousScoreListingData')
    createExtraReducersForThunk(builder, reportDataForStudentId, 'reportDataForStudentIdData')




  }
});

export const { logout } = userSlice.actions;

export default userSlice.reducer;